/*
  PRODUCT. Dresses up the Seal Subscriptions widget (rendered async by Seal into .sealsubs-container):
  - adds a benefits list under the Subscribe & save option (CSS highlights the option itself),
  - when a shopper picks Subscribe & save, switches the frequency from "week" to "2 weeks" once
    (a 500 mL jar lasts about two weeks); they can still change it.
  Preselects Subscribe & save once per widget (shoppers can switch to one-time).
  - while Subscribe & save is selected, labels the main price as the subscription price and shows the
    one-time price next to it (Seal swaps the main price to the discounted one with no context).
*/
(function () {
  var BENEFITS = [
    'Save on every delivery',
    'Every 2 to 6 weeks, you choose',
    'Skip, swap or cancel anytime',
    'Free pickup in Toronto & Mississauga'
  ];

  function enhance(container) {
    if (container.hasAttribute('data-sm-sub-ready')) return;
    var option = container.querySelector('.sls-option-container[data-selling-plan-group]');
    if (!option) return;
    container.setAttribute('data-sm-sub-ready', '');
    option.classList.add('sm-sub-option');

    var list = document.createElement('ul');
    list.className = 'sm-sub-benefits';
    list.setAttribute('role', 'list');
    BENEFITS.forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    });
    var label = option.querySelector('.sls-label-container');
    (label || option).appendChild(list);

    var radio = option.querySelector('input.sls-option[data-type="subscription"]');
    var nudged = false;
    function preferTwoWeeks() {
      if (nudged) return;
      var select = option.querySelector('select.sls-select');
      if (!select || select.selectedIndex !== 0) return;
      var two = Array.prototype.filter.call(select.options, function (o) { return /^2 weeks?$/i.test(o.textContent.trim()); })[0];
      if (!two) return;
      nudged = true;
      select.value = two.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    option.addEventListener('click', function () { setTimeout(preferTwoWeeks, 0); });
    if (radio) radio.addEventListener('change', preferTwoWeeks);
    // Default to Subscribe & save (Joaquim, Oct 31): select it once, then leave the shopper's choice alone.
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.click && setTimeout(function () { if (!radio.checked) radio.click(); }, 0);
    }
    setTimeout(preferTwoWeeks, 0);

    var info = container.closest('product-info, .product__info-wrapper');
    var price = info && info.querySelector('[id^="price-"]');
    if (price) {
      var note = document.createElement('p');
      note.className = 'sm-sub-price-note';
      note.setAttribute('data-sm-sub-price-note', '');
      price.insertAdjacentElement('afterend', note);
      var syncNote = function () {
        var oneTime = container.querySelector('.sls-one-time-price .sls-price');
        var on = radio && radio.checked && oneTime && oneTime.textContent.trim();
        note.hidden = !on;
        if (on) note.textContent = 'Subscribe & save price · ' + oneTime.textContent.trim() + ' one-time';
        // Seal sets the hidden selling_plan input in JS (no attribute change), so tell sm-pdp.js to refresh
        // the "Add to cart · $" label; it read the one-time price after the preselect otherwise.
        container.dispatchEvent(new CustomEvent('sm:plan-change', { bubbles: true }));
      };
      container.addEventListener('change', function () { setTimeout(syncNote, 0); });
      container.addEventListener('click', function () { setTimeout(syncNote, 0); });
      new MutationObserver(syncNote).observe(container, { childList: true, subtree: true, characterData: true });
      setTimeout(syncNote, 0);
    }
  }

  function scan() {
    document.querySelectorAll('.sls-purchase-options-container').forEach(enhance);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
